(function () {
  var WRAP_TYPES = [
    { selector: ".aiod-bundle-discount-wrap", type: "bundle" },
    { selector: ".aiod-bogo-discount-wrap", type: "bogo" },
    { selector: ".cs_free_p_msg.top_msg_main", type: "gift" },
    { selector: ".aiod-volume-discount-wrap", type: "volume" },
    { selector: ".aiod-wholesale-discount-topbar", type: "wholesale" },
  ];
  var WELL_LIMIT = 8;
  var DISCOUNT_API = "https://aiod.cirkleinc.com/api/display-discount-table";
  var TIER_WRAPS = {
    volume: ".aiod-volume-discount-wrap",
    wholesale: ".aiod-wholesale-discount-topbar",
  };

  function visibleText(el) {
    if (!el) return "";
    var clone = el.cloneNode(true);
    var skip = clone.querySelectorAll("style, script");
    Array.prototype.forEach.call(skip, function (node) {
      if (node.parentNode) node.parentNode.removeChild(node);
    });
    return (clone.textContent || "").replace(/\s+/g, " ").trim();
  }

  function hasVisibleContent(el) {
    if (!el) return false;
    if (visibleText(el).length > 0) return true;
    return Boolean(el.querySelector("img, table, svg"));
  }

  function parseI18n(host) {
    var node = host.querySelector("[data-sintco-aiod-progress-i18n]");
    if (!node) return {};
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return {};
    }
  }

  function interpolate(template, vars) {
    var out = String(template || "");
    Object.keys(vars).forEach(function (key) {
      out = out.split("__" + key + "__").join(String(vars[key]));
      out = out.split("{{ " + key + " }}").join(String(vars[key]));
      out = out.split("{{" + key + "}}").join(String(vars[key]));
    });
    return out;
  }

  function currentProductId() {
    var apps = window.csapps || {};
    if (apps.product_id) return String(apps.product_id);
    var meta = document.querySelector('meta[property="og:id"], [data-product-id]');
    if (meta && meta.getAttribute("content")) return String(meta.getAttribute("content"));
    if (meta && meta.getAttribute("data-product-id")) return String(meta.getAttribute("data-product-id"));
    return "";
  }

  function buildApiUrl(requestType) {
    var apps = window.csapps || {};
    var shopify = window.Shopify || {};
    var params = {
      product_id: apps.product_id || currentProductId(),
      shop: shopify.shop || "",
      collection_ids: apps.product_collections,
      request_type: requestType,
      currency: (shopify.currency && shopify.currency.active) || "CAD",
      country: shopify.country || "CA",
    };

    if (typeof apps.create_api_url === "function") {
      return apps.create_api_url(DISCOUNT_API, params);
    }

    var search = new URLSearchParams();
    Object.keys(params).forEach(function (key) {
      var value = params[key];
      if (value == null || value === "") return;
      if (Array.isArray(value)) search.set(key, value.join(","));
      else search.set(key, String(value));
    });
    return DISCOUNT_API + "?" + search.toString();
  }

  function fetchTable(requestType) {
    return fetch(buildApiUrl(requestType), { credentials: "omit" }).then(function (response) {
      if (!response.ok) throw new Error("discount-" + requestType);
      return response.json();
    });
  }

  function productIdsFrom(row) {
    return ((row && row.products) || [])
      .map(function (product) {
        return product && product.product_id != null ? String(product.product_id) : "";
      })
      .filter(Boolean);
  }

  function appliesToProduct(row, productId) {
    var ids = productIdsFrom(row);
    if (!ids.length) return true;
    return ids.indexOf(String(productId || "")) !== -1;
  }

  function firstVariantId(product) {
    if (!product || product.default_variant_ids == null) return "";
    return String(product.default_variant_ids).split(",")[0].trim();
  }

  function pickBogoOffer(payload, productId) {
    var rows = (payload && payload.data) || [];
    var pid = String(productId || "");
    var matches = [];

    rows.forEach(function (row) {
      if (String(row.status) !== "1") return;
      var buy = parseInt(row.bogo_quantity_buy, 10);
      if (!buy || buy < 1) return;
      if (!appliesToProduct(row, pid)) return;
      var ids = productIdsFrom(row);
      matches.push({
        buy: buy,
        productIds: ids.length ? ids : pid ? [pid] : [],
      });
    });

    matches.sort(function (a, b) {
      return a.buy - b.buy;
    });
    return matches[0] || null;
  }

  function mapBreakKind(rule) {
    var type = String((rule && rule.discount_type) || "");
    if (type === "0") return "percent";
    if (type === "2") return "amount";
    return "price";
  }

  function pickQtyTiers(payload, productId) {
    var rows = (payload && payload.data) || [];
    var pid = String(productId || "");
    var match = null;

    rows.forEach(function (row) {
      if (match) return;
      if (String(row.status) !== "1") return;
      if (!appliesToProduct(row, pid)) return;

      var rules = row.discount_quantities || [];
      var breaks = [];
      rules.forEach(function (rule) {
        var qty = parseInt(rule.quantity, 10);
        var value = Number(rule.discount_value);
        if (!qty || qty < 1 || !isFinite(value)) return;
        breaks.push({
          qty: qty,
          value: value,
          kind: mapBreakKind(rule),
        });
      });

      if (!breaks.length) return;
      breaks.sort(function (a, b) {
        return a.qty - b.qty;
      });

      var ids = productIdsFrom(row);
      match = {
        breaks: breaks,
        productIds: ids.length ? ids : pid ? [pid] : [],
      };
    });

    return match;
  }

  function pickTiersFromDom(host, wrapSelector, productId) {
    var wrap = host.querySelector(wrapSelector);
    if (!wrap) return null;
    var rows = wrap.querySelectorAll("table tbody tr");
    var breaks = [];
    var pid = String(productId || currentProductId() || "");

    Array.prototype.forEach.call(rows, function (row) {
      var qty = rowQty(row);
      if (!qty) return;
      var cells = row.querySelectorAll("td");
      var discountText = visibleText(cells[1] || cells[0] || row);
      var percent = discountText.match(/(\d+(?:\.\d+)?)\s*%/);
      var money = discountText.match(/\$\s*([\d,]+(?:\.\d{1,2})?)/);
      if (percent) {
        breaks.push({ qty: qty, value: Number(percent[1]), kind: "percent" });
        return;
      }
      if (money) {
        var kind = /each|for/i.test(discountText) ? "price" : "amount";
        breaks.push({
          qty: qty,
          value: parseFloat(money[1].replace(/,/g, "")),
          kind: kind,
        });
      }
    });

    if (!breaks.length) return null;
    breaks.sort(function (a, b) {
      return a.qty - b.qty;
    });
    return {
      breaks: breaks,
      productIds: pid ? [pid] : [],
    };
  }

  function pickBundle(payload, productId) {
    var rows = (payload && payload.data) || [];
    var pid = String(productId || "");
    var match = null;

    rows.forEach(function (row) {
      if (match) return;
      if (String(row.status) !== "1") return;
      var products = row.products || [];
      if (products.length < 2) return;
      if (!appliesToProduct(row, pid) && productIdsFrom(row).indexOf(pid) === -1) return;

      match = {
        products: products
          .map(function (product) {
            if (!product || product.product_id == null) return null;
            return {
              productId: String(product.product_id),
              handle: product.handle || "",
              variantId: firstVariantId(product),
              title: product.title || product.handle || "",
            };
          })
          .filter(Boolean),
      };
    });

    if (!match || match.products.length < 2) return null;
    return match;
  }

  function parseMoneyToCents(text) {
    var match = String(text || "").match(/\$\s*([\d,]+(?:\.\d{1,2})?)/);
    if (!match) return 0;
    var amount = parseFloat(match[1].replace(/,/g, ""));
    if (!isFinite(amount) || amount <= 0) return 0;
    return Math.round(amount * 100);
  }

  function parseGiftOffer(host, bogoOffer, giftActive) {
    if (!giftActive || bogoOffer) return null;
    var wrap = host.querySelector(".cs_free_p_msg.top_msg_main");
    var text = visibleText(wrap);
    if (!text) return null;

    var spendCents = parseMoneyToCents(text);
    var qtyMatch = text.match(/(?:buy|add)\s+(\d+)/i) || text.match(/(\d+)\s*(?:\+|or more)/i);
    var qty = qtyMatch ? parseInt(qtyMatch[1], 10) : 0;
    var pid = currentProductId();

    if (spendCents > 0 && (!qty || text.indexOf("$") !== -1)) {
      return { mode: "spend", goalCents: spendCents };
    }
    if (qty > 0) {
      return {
        mode: "qty",
        buy: qty,
        productIds: pid ? [pid] : [],
      };
    }
    return null;
  }

  function findQtyControl() {
    var selectors = [
      'form[action*="/cart/add"] [name="quantity"]',
      '[name="quantity"][form]',
      '[name="quantity"]',
      '[class*="product-qty-selector-input"]',
      '[class*="product-qty-selector-select"]',
    ];
    var i;
    for (i = 0; i < selectors.length; i += 1) {
      var el = document.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }

  function readSelectorQty() {
    var control = findQtyControl();
    if (!control) return 1;
    var value = parseInt(control.value, 10);
    return value > 0 ? value : 1;
  }

  function setSelectorQty(next) {
    var control = findQtyControl();
    if (!control) return;
    var min = parseInt(control.min, 10);
    var max = parseInt(control.max, 10);
    var value = next;
    if (min && value < min) value = min;
    if (max && value > max) value = max;
    if (value < 1) value = 1;
    control.value = String(value);
    control.dispatchEvent(new Event("input", { bubbles: true }));
    control.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function countQualifying(cart, productIds) {
    var allowed = {};
    (productIds || []).forEach(function (id) {
      allowed[String(id)] = true;
    });
    var total = 0;
    ((cart && cart.items) || []).forEach(function (item) {
      if (allowed[String(item.product_id)]) {
        total += Number(item.quantity) || 0;
      }
    });
    return total;
  }

  function cartHasProduct(cart, productId) {
    return countQualifying(cart, [productId]) > 0;
  }

  function formatMoney(value) {
    var amount = Number(value);
    if (!isFinite(amount)) return String(value);
    return "$" + amount.toFixed(2);
  }

  function formatCents(cents) {
    return formatMoney((Number(cents) || 0) / 100);
  }

  function formatPercent(value) {
    var amount = Number(value);
    if (!isFinite(amount)) return String(value);
    if (Math.abs(amount - Math.round(amount)) < 0.01) return String(Math.round(amount));
    return String(amount);
  }

  function readVariantPriceCents() {
    var form = document.querySelector('form[action*="/cart/add"]');
    var selected = form && form.querySelector('[name="id"]');
    var variantId = selected && selected.value;
    var meta =
      (window.ShopifyAnalytics &&
        ShopifyAnalytics.meta &&
        ShopifyAnalytics.meta.product) ||
      null;
    var variants = (meta && meta.variants) || [];
    var i;
    if (variantId) {
      for (i = 0; i < variants.length; i += 1) {
        if (String(variants[i].id) === String(variantId) && variants[i].price != null) {
          return Number(variants[i].price);
        }
      }
    }
    if (meta && meta.price != null) return Number(meta.price);

    var priceEl = document.querySelector("[data-product-price], .product__price .money, .price .money");
    var parsed = parseMoneyToCents(priceEl && priceEl.textContent);
    return parsed || 0;
  }

  function estimatedSpendCents(cart) {
    var subtotal = Number((cart && cart.items_subtotal_price) || 0);
    return subtotal + readVariantPriceCents() * readSelectorQty();
  }

  function hideEl(root, extraClass) {
    if (!root) return;
    root.hidden = true;
    root.classList.remove("is-active", "is-unlocked", "is-best", "is-complete");
    if (extraClass) root.classList.remove(extraClass);
  }

  function hideProgress(host) {
    hideEl(host.querySelector("[data-sintco-aiod-progress]"));
    host.classList.remove("has-bogo-progress");
  }

  function hideVolume(host) {
    var root = host.querySelector("[data-sintco-aiod-volume]");
    hideVolumeMeter(root);
    hideEl(root);
    clearTierMarks(host);
  }

  function hideBundle(host) {
    hideEl(host.querySelector("[data-sintco-aiod-bundle]"));
    clearBundleMarks(host);
  }

  function renderWells(wellsEl, goal, filled) {
    if (wellsEl.childElementCount !== goal) {
      wellsEl.textContent = "";
      var i;
      for (i = 0; i < goal; i += 1) {
        var well = document.createElement("span");
        well.className = "sintco-aiod-offer__well";
        well.setAttribute("aria-hidden", "true");
        wellsEl.appendChild(well);
      }
    }

    Array.prototype.forEach.call(wellsEl.children, function (well, index) {
      well.classList.toggle("is-filled", index < filled);
    });
  }

  function qtyOfferFromState(state) {
    if (state.bogo) return state.bogo;
    if (state.gift && state.gift.mode === "qty") return state.gift;
    return null;
  }

  function updateProgress(host) {
    var state = host._sintcoOffers;
    var root = host.querySelector("[data-sintco-aiod-progress]");
    if (!state || !root) {
      hideProgress(host);
      return;
    }

    if (state.gift && state.gift.mode === "spend") {
      updateGiftSpend(host);
      return;
    }

    var offer = qtyOfferFromState(state);
    if (!offer) {
      hideProgress(host);
      return;
    }

    var goal = offer.buy;
    var selectorQty = readSelectorQty();
    var cartQty = countQualifying(state.cart, offer.productIds);
    var current = Math.max(0, cartQty + selectorQty);
    var filled = Math.min(current, goal);
    var remaining = Math.max(0, goal - current);
    var unlocked = remaining === 0;
    var i18n = state.i18n || {};

    var statusEl = root.querySelector("[data-progress-status]");
    var countEl = root.querySelector("[data-progress-count]");
    var meterEl = root.querySelector("[data-progress-meter]");
    var wellsEl = root.querySelector("[data-progress-wells]");
    var trackEl = root.querySelector("[data-progress-track]");
    var fillEl = root.querySelector("[data-progress-fill]");
    var fillBtn = root.querySelector("[data-progress-fill-btn]");
    var useWells = goal <= WELL_LIMIT;

    var statusText = unlocked
      ? i18n.unlocked || "This order includes the gift"
      : interpolate(i18n.remaining || "Add {{ remaining }} more to get the gift", { remaining: remaining });
    var countText = interpolate(i18n.count || "{{ current }} of {{ goal }}", {
      current: filled,
      goal: goal,
    });

    if (statusEl) statusEl.textContent = statusText;
    if (countEl) {
      countEl.hidden = false;
      countEl.textContent = countText;
    }

    if (meterEl) {
      meterEl.hidden = false;
      meterEl.setAttribute("aria-valuemin", "0");
      meterEl.setAttribute("aria-valuenow", String(filled));
      meterEl.setAttribute("aria-valuemax", String(goal));
      meterEl.setAttribute("aria-valuetext", statusText + ". " + countText);
    }

    if (useWells) {
      if (trackEl) trackEl.hidden = true;
      if (wellsEl) {
        wellsEl.hidden = false;
        renderWells(wellsEl, goal, filled);
      }
    } else {
      if (wellsEl) {
        wellsEl.hidden = true;
        wellsEl.textContent = "";
      }
      if (trackEl) trackEl.hidden = false;
      if (fillEl) fillEl.style.width = Math.round((filled / goal) * 100) + "%";
    }

    if (fillBtn) {
      var qtyControl = findQtyControl();
      var neededFromSelector = Math.max(1, goal - cartQty);
      fillBtn.textContent = interpolate(i18n.fill || "Order {{ goal }} to get the gift", { goal: goal });
      fillBtn.hidden = !qtyControl || unlocked || selectorQty >= neededFromSelector;
    }

    root.hidden = false;
    root.classList.add("is-active");
    root.classList.toggle("is-unlocked", unlocked);
    host.classList.toggle("has-bogo-progress", true);
  }

  function updateGiftSpend(host) {
    var state = host._sintcoOffers;
    var root = host.querySelector("[data-sintco-aiod-progress]");
    if (!state || !state.gift || state.gift.mode !== "spend" || !root) {
      hideProgress(host);
      return;
    }

    var i18n = state.i18n || {};
    var goal = state.gift.goalCents;
    var current = Math.min(estimatedSpendCents(state.cart), goal);
    var remaining = Math.max(0, goal - estimatedSpendCents(state.cart));
    var unlocked = remaining === 0;
    var statusText = unlocked
      ? i18n.unlocked || "This order includes the gift"
      : interpolate(i18n.gift_spend || "{{ amount }} more on this order to add the gift", {
          amount: formatCents(remaining),
        });

    var statusEl = root.querySelector("[data-progress-status]");
    var countEl = root.querySelector("[data-progress-count]");
    var meterEl = root.querySelector("[data-progress-meter]");
    var wellsEl = root.querySelector("[data-progress-wells]");
    var trackEl = root.querySelector("[data-progress-track]");
    var fillEl = root.querySelector("[data-progress-fill]");
    var fillBtn = root.querySelector("[data-progress-fill-btn]");

    if (statusEl) statusEl.textContent = statusText;
    if (countEl) countEl.hidden = true;
    if (wellsEl) {
      wellsEl.hidden = true;
      wellsEl.textContent = "";
    }
    if (trackEl) trackEl.hidden = false;
    if (fillEl) fillEl.style.width = goal ? Math.round((current / goal) * 100) + "%" : "0%";
    if (fillBtn) fillBtn.hidden = true;
    if (meterEl) {
      meterEl.hidden = false;
      meterEl.setAttribute("aria-valuemin", "0");
      meterEl.setAttribute("aria-valuenow", String(current));
      meterEl.setAttribute("aria-valuemax", String(goal));
      meterEl.setAttribute("aria-valuetext", statusText);
    }

    root.hidden = false;
    root.classList.add("is-active");
    root.classList.toggle("is-unlocked", unlocked);
    host.classList.toggle("has-bogo-progress", true);
  }

  function clearTierMarks(host) {
    var rows = host.querySelectorAll(
      ".aiod-volume-discount-wrap table tbody tr, .aiod-wholesale-discount-topbar table tbody tr"
    );
    Array.prototype.forEach.call(rows, function (row) {
      row.classList.remove("is-current", "is-next");
    });
  }

  function rowQty(row) {
    var cell = row.querySelector("td");
    var text = visibleText(cell || row);
    var labeled = text.match(/(?:buy|qty|quantity|min)\s*(\d+)/i) || text.match(/(\d+)\s*\+/i);
    if (labeled) return parseInt(labeled[1], 10);
    if (/^\d+\+?$/.test(text.replace(/\s/g, ""))) return parseInt(text, 10);
    return 0;
  }

  function markTierRows(host, wrapSelector, currentBreak, nextBreak) {
    var wrap = host.querySelector(wrapSelector);
    if (!wrap) return;
    var rows = wrap.querySelectorAll("table tbody tr");
    Array.prototype.forEach.call(rows, function (row) {
      var qty = rowQty(row);
      row.classList.toggle("is-current", Boolean(currentBreak && qty === currentBreak.qty));
      row.classList.toggle("is-next", Boolean(nextBreak && qty === nextBreak.qty));
    });
  }

  function volumeCopy(i18n, key, vars, fallback) {
    return interpolate(i18n[key] || fallback, vars);
  }

  function breakVars(tier, extra) {
    var vars = extra || {};
    vars.qty = tier.qty;
    vars.percent = formatPercent(tier.value);
    vars.amount = formatMoney(tier.value);
    return vars;
  }

  function statusForTiers(i18n, currentBreak, nextBreak, remaining) {
    if (nextBreak && !currentBreak) {
      if (nextBreak.kind === "percent") {
        return volumeCopy(i18n, "volume_next_percent", breakVars(nextBreak, { remaining: remaining }), "Add {{ remaining }} more for {{ percent }}% off");
      }
      if (nextBreak.kind === "amount") {
        return volumeCopy(i18n, "volume_next_amount", breakVars(nextBreak, { remaining: remaining }), "Add {{ remaining }} more to save {{ amount }}");
      }
      return volumeCopy(i18n, "volume_next_price", breakVars(nextBreak, { remaining: remaining }), "Add {{ remaining }} more to get {{ amount }} each");
    }

    if (currentBreak && nextBreak) {
      if (currentBreak.kind === "percent") {
        return volumeCopy(i18n, "volume_current_percent", breakVars(currentBreak), "This quantity gets {{ percent }}% off");
      }
      if (currentBreak.kind === "amount") {
        return volumeCopy(i18n, "volume_current_amount", breakVars(currentBreak), "This quantity saves {{ amount }}");
      }
      return volumeCopy(i18n, "volume_current_price", breakVars(currentBreak), "This quantity is {{ amount }} each");
    }

    return i18n.volume_best || "Best price on this order";
  }

  function orderCopy(i18n, tier) {
    if (tier.kind === "percent") {
      return volumeCopy(i18n, "volume_order_percent", breakVars(tier), "Order {{ qty }} to get {{ percent }}% off");
    }
    if (tier.kind === "amount") {
      return volumeCopy(i18n, "volume_order_amount", breakVars(tier), "Order {{ qty }} to save {{ amount }}");
    }
    return volumeCopy(i18n, "volume_order_price", breakVars(tier), "Order {{ qty }} to get {{ amount }} each");
  }

  function readTierPosition(offer, cart) {
    if (!offer || !offer.breaks || !offer.breaks.length) return null;
    var selectorQty = readSelectorQty();
    var cartQty = countQualifying(cart, offer.productIds);
    var current = Math.max(0, cartQty + selectorQty);
    var currentBreak = null;
    var nextBreak = null;
    var i;
    for (i = 0; i < offer.breaks.length; i += 1) {
      if (current >= offer.breaks[i].qty) currentBreak = offer.breaks[i];
      else if (!nextBreak) nextBreak = offer.breaks[i];
    }
    return {
      offer: offer,
      cartQty: cartQty,
      selectorQty: selectorQty,
      current: current,
      currentBreak: currentBreak,
      nextBreak: nextBreak,
      remaining: nextBreak ? Math.max(0, nextBreak.qty - current) : 0,
      atTop: Boolean(currentBreak) && !nextBreak,
    };
  }

  function hideVolumeMeter(root) {
    var meterRow = root && root.querySelector("[data-volume-meter]");
    if (meterRow) meterRow.hidden = true;
  }

  function updateVolumeMeter(host, root, primary) {
    var meterRow = root.querySelector("[data-volume-meter]");
    if (!meterRow) return;

    if (host.classList.contains("has-bogo-progress")) {
      hideVolumeMeter(root);
      return;
    }

    var goalTier =
      primary.nextBreak ||
      primary.currentBreak ||
      (primary.offer.breaks && primary.offer.breaks[primary.offer.breaks.length - 1]) ||
      null;
    var goal = goalTier ? goalTier.qty : 0;
    if (!goal) {
      hideVolumeMeter(root);
      return;
    }

    var filled = Math.min(primary.current, goal);
    var i18n = (host._sintcoOffers && host._sintcoOffers.i18n) || {};
    var countText = interpolate(i18n.count || "{{ current }} of {{ goal }}", {
      current: filled,
      goal: goal,
    });
    var meterEl = meterRow.querySelector("[data-volume-progress-meter]");
    var wellsEl = meterRow.querySelector("[data-volume-wells]");
    var trackEl = meterRow.querySelector("[data-volume-track]");
    var fillEl = meterRow.querySelector("[data-volume-track-fill]");
    var countEl = meterRow.querySelector("[data-volume-count]");
    var useWells = goal <= WELL_LIMIT;

    if (countEl) {
      countEl.hidden = false;
      countEl.textContent = countText;
    }

    if (meterEl) {
      meterEl.setAttribute("aria-valuemin", "0");
      meterEl.setAttribute("aria-valuenow", String(filled));
      meterEl.setAttribute("aria-valuemax", String(goal));
      meterEl.setAttribute("aria-valuetext", countText);
    }

    if (useWells) {
      if (trackEl) trackEl.hidden = true;
      if (wellsEl) {
        wellsEl.hidden = false;
        renderWells(wellsEl, goal, filled);
      }
    } else {
      if (wellsEl) {
        wellsEl.hidden = true;
        wellsEl.textContent = "";
      }
      if (trackEl) trackEl.hidden = false;
      if (fillEl) fillEl.style.width = Math.round((filled / goal) * 100) + "%";
    }

    meterRow.hidden = false;
  }

  function updateVolume(host) {
    var state = host._sintcoOffers;
    var root = host.querySelector("[data-sintco-aiod-volume]");
    var volumePos = state && readTierPosition(state.volume, state.cart);
    var wholesalePos = state && readTierPosition(state.wholesale, state.cart);
    var primary = volumePos || wholesalePos;
    if (!state || !root || !primary) {
      hideVolume(host);
      return;
    }

    var i18n = state.i18n || {};
    var statusText = statusForTiers(i18n, primary.currentBreak, primary.nextBreak, primary.remaining);
    var statusEl = root.querySelector("[data-volume-status]");
    var fillBtn = root.querySelector("[data-volume-fill-btn]");

    if (statusEl) statusEl.textContent = statusText;

    updateVolumeMeter(host, root, primary);

    clearTierMarks(host);
    if (volumePos) {
      markTierRows(host, TIER_WRAPS.volume, volumePos.currentBreak, volumePos.nextBreak);
    }
    if (wholesalePos) {
      markTierRows(host, TIER_WRAPS.wholesale, wholesalePos.currentBreak, wholesalePos.nextBreak);
    }

    if (fillBtn) {
      var qtyControl = findQtyControl();
      var target = primary.nextBreak || (!primary.currentBreak && primary.offer.breaks[0]) || null;
      if (!qtyControl || !target || primary.atTop) {
        fillBtn.hidden = true;
      } else {
        var neededFromSelector = Math.max(1, target.qty - primary.cartQty);
        fillBtn.textContent = orderCopy(i18n, target);
        fillBtn.hidden = primary.selectorQty >= neededFromSelector;
        fillBtn.setAttribute("data-volume-qty", String(neededFromSelector));
      }
    }

    root.hidden = false;
    root.classList.add("is-active");
    root.classList.toggle("is-best", primary.atTop);
  }

  function clearBundleMarks(host) {
    var rows = host.querySelectorAll(".aiod-bundle-discount-wrap table tbody tr");
    Array.prototype.forEach.call(rows, function (row) {
      row.classList.remove("is-in-set");
    });
  }

  function productInSet(product, cart) {
    if (cartHasProduct(cart, product.productId)) return true;
    return product.productId === currentProductId() && readSelectorQty() > 0;
  }

  function rowMatchesProduct(rowText, product) {
    if (product.handle && rowText.indexOf(String(product.handle).toLowerCase()) !== -1) return true;
    if (product.title && rowText.indexOf(String(product.title).toLowerCase()) !== -1) return true;
    return rowText.indexOf(String(product.productId)) !== -1;
  }

  function markBundleRows(host, products, cart) {
    var wrap = host.querySelector(".aiod-bundle-discount-wrap");
    if (!wrap) return;
    var rows = wrap.querySelectorAll("table tbody tr");
    Array.prototype.forEach.call(rows, function (row) {
      var text = visibleText(row).toLowerCase();
      var inSet = products.some(function (product) {
        return productInSet(product, cart) && rowMatchesProduct(text, product);
      });
      row.classList.toggle("is-in-set", inSet);
    });
  }

  function bundlePresentCount(bundle, cart) {
    var pid = currentProductId();
    var count = 0;
    bundle.products.forEach(function (product) {
      if (cartHasProduct(cart, product.productId)) {
        count += 1;
        return;
      }
      if (product.productId === pid && readSelectorQty() > 0) count += 1;
    });
    return count;
  }

  function missingBundleItems(bundle, cart) {
    var pid = currentProductId();
    return bundle.products.filter(function (product) {
      if (cartHasProduct(cart, product.productId)) return false;
      if (product.productId === pid) return false;
      return Boolean(product.variantId);
    });
  }

  function updateBundle(host) {
    var state = host._sintcoOffers;
    var root = host.querySelector("[data-sintco-aiod-bundle]");
    if (!state || !state.bundle || !root) {
      hideBundle(host);
      return;
    }

    var i18n = state.i18n || {};
    var goal = state.bundle.products.length;
    var current = Math.min(bundlePresentCount(state.bundle, state.cart), goal);
    var complete = current >= goal;
    var statusEl = root.querySelector("[data-bundle-status]");
    var countEl = root.querySelector("[data-bundle-count]");
    var addBtn = root.querySelector("[data-bundle-add-btn]");
    var missing = missingBundleItems(state.bundle, state.cart);

    if (statusEl) {
      statusEl.textContent = complete
        ? i18n.bundle_complete || "This set is in the order"
        : i18n.bundle_incomplete || "Add the rest of this set";
    }
    if (countEl) {
      countEl.textContent = interpolate(i18n.bundle_count || "{{ current }} of {{ goal }} in this set", {
        current: current,
        goal: goal,
      });
    }
    if (addBtn) {
      addBtn.hidden = complete || missing.length === 0;
    }

    clearBundleMarks(host);
    markBundleRows(host, state.bundle.products, state.cart);

    root.hidden = false;
    root.classList.add("is-active");
    root.classList.toggle("is-complete", complete);
  }

  function polishOfferMedia(host) {
    var name = host.querySelector(".cs-bogo-name");
    var label = name ? (name.textContent || "").replace(/\s+/g, " ").trim() : "";
    host.querySelectorAll(".aiod-bogo-discount-wrap img, .cs_free_p_msg img").forEach(function (img) {
      var alt = (img.getAttribute("alt") || "").trim();
      if (!alt || alt.toLowerCase() === "null") {
        img.setAttribute("alt", label || "Gift with this order");
      }
    });
  }

  function updateAll(host) {
    var state = host._sintcoOffers;
    if (state) {
      var pid = currentProductId();
      if (!state.volume && host.getAttribute("data-offer-volume") === "true") {
        state.volume = pickTiersFromDom(host, TIER_WRAPS.volume, pid);
      }
      if (!state.wholesale && host.getAttribute("data-offer-wholesale") === "true") {
        state.wholesale = pickTiersFromDom(host, TIER_WRAPS.wholesale, pid);
      }
      state.gift = parseGiftOffer(
        host,
        state.bogo,
        host.getAttribute("data-offer-gift") === "true"
      );
    }
    polishOfferMedia(host);
    updateProgress(host);
    updateVolume(host);
    updateBundle(host);
  }

  function bindOfferEvents(host) {
    if (host.getAttribute("data-sintco-offers-bound") === "true") return;
    host.setAttribute("data-sintco-offers-bound", "true");

    document.addEventListener("input", function (event) {
      var target = event.target;
      if (!target || target.name !== "quantity") return;
      updateAll(host);
    });
    document.addEventListener("change", function (event) {
      var target = event.target;
      if (!target || target.name !== "quantity") return;
      updateAll(host);
    });

    var fillBtn = host.querySelector("[data-progress-fill-btn]");
    if (fillBtn) {
      fillBtn.addEventListener("click", function () {
        var state = host._sintcoOffers;
        var offer = state && qtyOfferFromState(state);
        if (!offer) return;
        var cartQty = countQualifying(state.cart, offer.productIds);
        setSelectorQty(Math.max(1, offer.buy - cartQty));
        updateAll(host);
      });
    }

    var volumeBtn = host.querySelector("[data-volume-fill-btn]");
    if (volumeBtn) {
      volumeBtn.addEventListener("click", function () {
        var qty = parseInt(volumeBtn.getAttribute("data-volume-qty"), 10);
        if (!qty) return;
        setSelectorQty(qty);
        updateAll(host);
      });
    }

    var bundleBtn = host.querySelector("[data-bundle-add-btn]");
    if (bundleBtn) {
      bundleBtn.addEventListener("click", function () {
        var state = host._sintcoOffers;
        if (!state || !state.bundle) return;
        var missing = missingBundleItems(state.bundle, state.cart);
        if (!missing.length) return;
        var items = missing.map(function (product) {
          return { id: Number(product.variantId), quantity: 1 };
        });
        fetch("/cart/add.js", {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: items }),
        })
          .then(function (response) {
            if (!response.ok) throw new Error("cart-add");
            return refreshCart(host);
          })
          .catch(function () {});
      });
    }

    document.addEventListener("submit", function (event) {
      var form = event.target;
      if (!form || !form.getAttribute) return;
      var action = form.getAttribute("action") || "";
      if (action.indexOf("/cart/add") === -1) return;
      window.setTimeout(function () {
        refreshCart(host);
      }, 900);
    });

    ["cart:updated", "cart:refresh", "cart:change"].forEach(function (name) {
      document.addEventListener(name, function () {
        refreshCart(host);
      });
    });

    window.addEventListener("pageshow", function () {
      refreshCart(host);
    });

    var qtyRoot = document.querySelector('[id*="product-qty-selector"]');
    if (qtyRoot && window.MutationObserver) {
      var qtyObserver = new MutationObserver(function () {
        updateAll(host);
      });
      qtyObserver.observe(qtyRoot, { childList: true, subtree: true });
    }
  }

  function refreshCart(host) {
    var state = host._sintcoOffers;
    if (!state) return;
    return fetch("/cart.js", { credentials: "same-origin" })
      .then(function (response) {
        if (!response.ok) throw new Error("cart");
        return response.json();
      })
      .then(function (cart) {
        state.cart = cart;
        updateAll(host);
      })
      .catch(function () {
        updateAll(host);
      });
  }

  function startOffers(host) {
    if (host.getAttribute("data-sintco-offers-loading") === "true") {
      if (host._sintcoOffers) updateAll(host);
      return;
    }
    host.setAttribute("data-sintco-offers-loading", "true");

    var i18n = parseI18n(host);
    var attempts = 0;

    function begin() {
      loadOffers(host, i18n, currentProductId());
    }

    if (currentProductId()) {
      begin();
      return;
    }

    var wait = window.setInterval(function () {
      attempts += 1;
      if (currentProductId() || attempts > 40) {
        window.clearInterval(wait);
        if (currentProductId()) begin();
        else {
          hideProgress(host);
          hideVolume(host);
          hideBundle(host);
        }
      }
    }, 100);
  }

  function emptyOnError() {
    return { data: [] };
  }

  function loadOffers(host, i18n, productId) {
    var giftActive = host.getAttribute("data-offer-gift") === "true";

    Promise.all([
      fetchTable(3).catch(emptyOnError),
      fetchTable(1).catch(emptyOnError),
      fetchTable(2).catch(emptyOnError),
      fetchTable(0).catch(emptyOnError),
      fetch("/cart.js", { credentials: "same-origin" })
        .then(function (response) {
          if (!response.ok) throw new Error("cart");
          return response.json();
        })
        .catch(function () {
          return { items: [], items_subtotal_price: 0 };
        }),
    ]).then(function (results) {
      var bogo = pickBogoOffer(results[0], productId);
      host._sintcoOffers = {
        i18n: i18n,
        cart: results[4],
        bogo: bogo,
        volume: pickQtyTiers(results[1], productId) || pickTiersFromDom(host, TIER_WRAPS.volume, productId),
        wholesale: pickQtyTiers(results[2], productId) || pickTiersFromDom(host, TIER_WRAPS.wholesale, productId),
        gift: parseGiftOffer(host, bogo, giftActive),
        bundle: pickBundle(results[3], productId),
      };
      bindOfferEvents(host);
      updateAll(host);
    });
  }

  function syncHost(host) {
    var activeTypes = [];

    WRAP_TYPES.forEach(function (entry) {
      var nodes = host.querySelectorAll(entry.selector);
      var typeActive = false;

      nodes.forEach(function (node) {
        var active = hasVisibleContent(node);
        node.setAttribute("data-sintco-aiod-active", active ? "true" : "false");
        if (active) typeActive = true;
      });

      host.setAttribute("data-offer-" + entry.type, typeActive ? "true" : "false");
      if (typeActive) activeTypes.push(entry.type);
    });

    var visible = activeTypes.length > 0;
    host.classList.toggle("is-visible", visible);
    host.setAttribute("aria-hidden", visible ? "false" : "true");
    if (visible) {
      host.setAttribute("data-offer-type", activeTypes.join(" "));
      startOffers(host);
      return;
    }

    host.removeAttribute("data-offer-type");
    hideProgress(host);
    hideVolume(host);
    hideBundle(host);
  }

  function observeHost(host) {
    if (host.getAttribute("data-sintco-aiod-ready") === "true") {
      syncHost(host);
      return;
    }

    host.setAttribute("data-sintco-aiod-ready", "true");
    syncHost(host);

    var slot = host.querySelector(".sintco-aiod-offer__slot") || host;
    var observer = new MutationObserver(function () {
      syncHost(host);
    });

    observer.observe(slot, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  function init() {
    document.querySelectorAll("[data-sintco-aiod-offer]").forEach(observeHost);
  }

  var previousCallback = window.csrundata;
  window.csrundata = function () {
    if (typeof previousCallback === "function") {
      previousCallback.apply(this, arguments);
    }
    init();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
